
import { 
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow 
} from "@/components/ui/table";

export interface ActivityLogItem {
  id: string;
  timestamp: string;
  action: string;
  project: string;
  scope: string;
}

interface ActivityLogTableProps {
  activities: ActivityLogItem[];
}

const ActivityLogTable = ({ activities }: ActivityLogTableProps) => {
  return (
    <div className="w-full overflow-x-auto">
      <div className="table-container min-w-[600px]">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[180px]">Timestamp</TableHead>
              <TableHead>Action</TableHead>
              <TableHead>Project</TableHead>
              <TableHead className="w-[150px]">Scope</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {activities.map((activity) => (
              <TableRow key={activity.id}>
                <TableCell className="font-geist-mono text-sm">
                  {activity.timestamp}
                </TableCell>
                <TableCell>{activity.action}</TableCell>
                <TableCell>{activity.project}</TableCell>
                <TableCell>
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-recallio-light-gray">
                    {activity.scope}
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default ActivityLogTable;
